// extracted by mini-css-extract-plugin
export var formContainer = "_jq-0";
export var message = "_jq-1";